import {createRequest, makeRequest, prepareRequest} from "../utils/apiUtil";

export function getAll(filters = {}, includes = [], extraParams = {}) {
    return makeRequest(createRequest('admin'), prepareRequest(filters, includes, extraParams));
}
export function getById(id, includes = []) {
    return makeRequest(createRequest('admin/' + id), prepareRequest({}, includes));
}